export var SecurityIOCFeedsFeedTypes;
(function (SecurityIOCFeedsFeedTypes) {
    SecurityIOCFeedsFeedTypes["PRIVATE"] = "PRIVATE";
    SecurityIOCFeedsFeedTypes["LOGZIO"] = "LOGZIO";
    SecurityIOCFeedsFeedTypes["REPOSITORY"] = "REPOSITORY";
})(SecurityIOCFeedsFeedTypes || (SecurityIOCFeedsFeedTypes = {}));
export var SecurityIOCFeedsFeedTypesTags;
(function (SecurityIOCFeedsFeedTypesTags) {
    SecurityIOCFeedsFeedTypesTags["PRIVATE"] = "Private feed";
    SecurityIOCFeedsFeedTypesTags["LOGZIO"] = "Logz.io feed";
    SecurityIOCFeedsFeedTypesTags["REPOSITORY"] = "Repository";
})(SecurityIOCFeedsFeedTypesTags || (SecurityIOCFeedsFeedTypesTags = {}));
export var SecurityIOCFeedsSyncStatus;
(function (SecurityIOCFeedsSyncStatus) {
    SecurityIOCFeedsSyncStatus["PAUSED"] = "PAUSED";
    SecurityIOCFeedsSyncStatus["ACTIVE"] = "ACTIVE";
    SecurityIOCFeedsSyncStatus["PENDING"] = "PENDING";
})(SecurityIOCFeedsSyncStatus || (SecurityIOCFeedsSyncStatus = {}));
export var SecurityIOCFeedsErrorCode;
(function (SecurityIOCFeedsErrorCode) {
    SecurityIOCFeedsErrorCode["FEED_SIZE_LIMIT_REACHED"] = "FEED_SIZE_LIMIT_REACHED";
    SecurityIOCFeedsErrorCode["PARSING_ERROR"] = "PARSING_ERROR";
    SecurityIOCFeedsErrorCode["CONNECTION_SERVER_ERROR"] = "CONNECTION_SERVER_ERROR";
    SecurityIOCFeedsErrorCode["CONNECTION_UNAUTHORIZED"] = "CONNECTION_UNAUTHORIZED";
    SecurityIOCFeedsErrorCode["INTERNAL_ERROR"] = "INTERNAL_ERROR";
})(SecurityIOCFeedsErrorCode || (SecurityIOCFeedsErrorCode = {}));
export var SecurityIOCFeedsSyncStatusText;
(function (SecurityIOCFeedsSyncStatusText) {
    SecurityIOCFeedsSyncStatusText["Pending"] = "Pending...";
    SecurityIOCFeedsSyncStatusText["Processing"] = "Processing...";
    SecurityIOCFeedsSyncStatusText["Paused"] = "Sync paused";
})(SecurityIOCFeedsSyncStatusText || (SecurityIOCFeedsSyncStatusText = {}));
export var SecurityIOCFeedsIOCType;
(function (SecurityIOCFeedsIOCType) {
    SecurityIOCFeedsIOCType["IP"] = "IP";
    SecurityIOCFeedsIOCType["DNS"] = "DNS";
    SecurityIOCFeedsIOCType["URL"] = "URL";
    SecurityIOCFeedsIOCType["MD5"] = "MD5";
    SecurityIOCFeedsIOCType["SHA1"] = "SHA1";
    SecurityIOCFeedsIOCType["SHA256"] = "SHA256";
    SecurityIOCFeedsIOCType["USER_AGENT"] = "USER_AGENT";
    SecurityIOCFeedsIOCType["CUSTOM"] = "CUSTOM";
})(SecurityIOCFeedsIOCType || (SecurityIOCFeedsIOCType = {}));
export var SecurityIOCFeedsIOCTypeLabel;
(function (SecurityIOCFeedsIOCTypeLabel) {
    SecurityIOCFeedsIOCTypeLabel["IP"] = "IP";
    SecurityIOCFeedsIOCTypeLabel["DNS"] = "DNS";
    SecurityIOCFeedsIOCTypeLabel["URL"] = "URL";
    SecurityIOCFeedsIOCTypeLabel["MD5"] = "MD5";
    SecurityIOCFeedsIOCTypeLabel["SHA1"] = "SHA1";
    SecurityIOCFeedsIOCTypeLabel["SHA256"] = "SHA256";
    SecurityIOCFeedsIOCTypeLabel["USER_AGENT"] = "USER-AGENT";
    SecurityIOCFeedsIOCTypeLabel["CUSTOM"] = "CUSTOM";
})(SecurityIOCFeedsIOCTypeLabel || (SecurityIOCFeedsIOCTypeLabel = {}));
export var SecurityIOCFeedsFeedFormat;
(function (SecurityIOCFeedsFeedFormat) {
    SecurityIOCFeedsFeedFormat["STIX"] = "STIX";
    SecurityIOCFeedsFeedFormat["SAWMILL_PIPELINE"] = "SAWMILL_PIPELINE";
})(SecurityIOCFeedsFeedFormat || (SecurityIOCFeedsFeedFormat = {}));
export var SecurityIOCFeedsFeedConfidences;
(function (SecurityIOCFeedsFeedConfidences) {
    SecurityIOCFeedsFeedConfidences["LOW"] = "LOW";
    SecurityIOCFeedsFeedConfidences["LOW_MEDIUM"] = "LOW_MEDIUM";
    SecurityIOCFeedsFeedConfidences["MEDIUM"] = "MEDIUM";
    SecurityIOCFeedsFeedConfidences["MEDIUM_HIGH"] = "MEDIUM_HIGH";
    SecurityIOCFeedsFeedConfidences["HIGH"] = "HIGH";
})(SecurityIOCFeedsFeedConfidences || (SecurityIOCFeedsFeedConfidences = {}));
export var SecurityIOCFeedTestSubjects;
(function (SecurityIOCFeedTestSubjects) {
    SecurityIOCFeedTestSubjects["FeedTable"] = "feed-table";
    SecurityIOCFeedTestSubjects["TableEmptyState"] = "table-empty-state";
    SecurityIOCFeedTestSubjects["TableEmptyStateText"] = "table-empty-state-text";
    SecurityIOCFeedTestSubjects["IocSearchInput"] = "ioc-search-input";
    SecurityIOCFeedTestSubjects["IocSearchButton"] = "ioc-search-button";
    SecurityIOCFeedTestSubjects["ThreatsFeedsPage"] = "threats-feeds-page";
    SecurityIOCFeedTestSubjects["PrivateFeedIcon"] = "PrivateFeedIcon";
    SecurityIOCFeedTestSubjects["LogzioFeedIcon"] = "LogzioFeedIcon";
    SecurityIOCFeedTestSubjects["RepositoryFeedIcon"] = "Repository";
    SecurityIOCFeedTestSubjects["NewPrivateFeedButton"] = "NewPrivateFeedButton";
    SecurityIOCFeedTestSubjects["ReSyncPausedPrivateFeedButton"] = "ReSyncPausedPrivateFeedButton";
    SecurityIOCFeedTestSubjects["FeedSyncIndicationErrorIcon"] = "FeedSyncIndicationErrorIcon";
    SecurityIOCFeedTestSubjects["FeedsSearchErrorNotification"] = "FeedsSearchError";
    SecurityIOCFeedTestSubjects["IocSearchErrorNotification"] = "IocSearchError";
    SecurityIOCFeedTestSubjects["FeedReSyncSuccessNotification"] = "FeedReSyncSuccessNotification";
    SecurityIOCFeedTestSubjects["PrivateFeedDeleteSuccessNotification"] = "privateFeedDeleteSuccessNotification";
    SecurityIOCFeedTestSubjects["PrivateFeedFormNameInput"] = "PrivateFeedFormNameInput";
    SecurityIOCFeedTestSubjects["PrivateFeedFormDescriptionInput"] = "PrivateFeedFormDescriptionInput";
    SecurityIOCFeedTestSubjects["PrivateFeedFormIocTypeSelect"] = "PrivateFeedFormIocTypeSelect";
    SecurityIOCFeedTestSubjects["PrivateFeedFormPipelineSelect"] = "PrivateFeedFormPipelineSelect";
    SecurityIOCFeedTestSubjects["PrivateFeedFormCompressionSelect"] = "PrivateFeedFormCompressionSelect";
    SecurityIOCFeedTestSubjects["PrivateFeedFormSeveritySelect"] = "PrivateFeedFormSeveritySelect";
    SecurityIOCFeedTestSubjects["PrivateFeedFormFeedStixToggle"] = "PrivateFeedFormFeedStixToggle";
    SecurityIOCFeedTestSubjects["PrivateFeedFormFeedEnableToggle"] = "PrivateFeedFormFeedEnableToggle";
    SecurityIOCFeedTestSubjects["PrivateFeedFormReliabilitySelect"] = "PrivateFeedFormReliabilitySelect";
    SecurityIOCFeedTestSubjects["PrivateFeedFormUrlInput"] = "PrivateFeedFormUrlInput";
    SecurityIOCFeedTestSubjects["PrivateFeedFormSourceUrlInput"] = "PrivateFeedFormSourceUrlInput";
    SecurityIOCFeedTestSubjects["PrivateFeedFormMethodSelect"] = "PrivateFeedFormMethodSelect";
    SecurityIOCFeedTestSubjects["PrivateFeedFormHeadersInput"] = "PrivateFeedFormHeadersInput";
    SecurityIOCFeedTestSubjects["PrivateFeedFormBodyInput"] = "PrivateFeedFormBodyInput";
    SecurityIOCFeedTestSubjects["PrivateFeedFormPage"] = "PrivateFeedFormPage";
    SecurityIOCFeedTestSubjects["PrivateFeedFormUpdated"] = "PrivateFeedFormUpdated";
    SecurityIOCFeedTestSubjects["PrivateFeedFormCreated"] = "PrivateFeedFormCreated";
})(SecurityIOCFeedTestSubjects || (SecurityIOCFeedTestSubjects = {}));
export var SecurityIOCFeedsRoutingStates;
(function (SecurityIOCFeedsRoutingStates) {
    SecurityIOCFeedsRoutingStates["Table"] = "dashboard.security.threats.feeds";
    SecurityIOCFeedsRoutingStates["New"] = "dashboard.security.threats.feeds-new";
    SecurityIOCFeedsRoutingStates["Edit"] = "dashboard.security.threats.feeds-edit";
})(SecurityIOCFeedsRoutingStates || (SecurityIOCFeedsRoutingStates = {}));
//# sourceMappingURL=security-ioc-feeds.enum.js.map